/**
 * Wave Divider SVG Generator — Tool Manifest
 */
import type { ToolManifest } from "../../../lib/tool";

export const manifest: ToolManifest = {
  id: "wave-divider-svg-generator",
  name: "Wave Divider SVG Generator",
  description: "Generate SVG wave dividers for website section transitions. Customizable amplitude, frequency, color.",
  category: "image",
  keywords: ["wave divider", "svg wave", "section divider", "wave svg"],
  icon: "Waves",
  requiresNetwork: false,
  seo: {
    title: "Wave Divider SVG Generator — 100% Private, Offline | UnQTools",
    faq: [
      { q: "What does this tool do?", a: "Generate SVG wave dividers for website section transitions. Customizable amplitude, frequency, color." },
      { q: "Is my data sent to a server?", a: "No. This tool runs 100% in your browser. Nothing is uploaded, tracked, or stored remotely." },
      { q: "What extra features does this tool have?", a: "Extras: (1) (1) Wave shape generation, (2) (2) Amplitude control, (3) (3) Frequency control, (4) (4) Color picker, (5) (5) Direction (top/bottom), (6) (6) Multiple layers, (7) (7) SVG export, (8) (8) PNG export, (9) (9) Copy SVG, (10) (10) Copy CSS, (11) (11) Live preview, (12) (12) PWA offline" },
      { q: "Does this work offline?", a: "Yes — install as a PWA and use it without network." },
    ],
  },
  status: "done",
};
